import React, { useEffect, useState } from 'react'
import { Route } from 'react-router-dom'

import ClientEdit from 'pages/sale/client/edit'
import ClientNew from 'pages/sale/client/new'
import ClientSearch from 'pages/sale/client/search'

import ProposalEdit from 'pages/sale/proposal/edit'
import ProposalNew from 'pages/sale/proposal/new'
import ProposalSearch from 'pages/sale/proposal/search'

import { MenuPermission } from 'components/layout/components/menu/types'
import { useAuth } from 'contexts/auth/auth-context'

const Routes: React.FC = () => {
  const { user, getMenuPermission } = useAuth()
  const [menuPermission, setMenuPermission] = useState<MenuPermission>()

  useEffect(() => {
    setMenuPermission(getMenuPermission())
  }, [user?.permissions])

  return (
    <>
      {menuPermission?.sale.client && (
        <>
          <Route path='/sale/client/edit/:id' exact component={ClientEdit} />
          <Route path='/sale/client/new' exact component={ClientNew} />
          <Route path='/sale/client/search' exact component={ClientSearch} />
        </>
      )}

      {menuPermission?.sale.proposal && (
        <>
          <Route path='/sale/proposal/edit/:id' exact component={ProposalEdit} />
          <Route path='/sale/proposal/new' exact component={ProposalNew} />
          <Route path='/sale/proposal/search' exact component={ProposalSearch} />
        </>
      )}
    </>
  )
}

export default Routes
